import { useMemo } from 'react';

import { Tournament } from '@features/shared/api/typings';
import { ALL_TABS } from '@features/tournament/ui/components/TournamentParticipantsEdit/types';

export function useTabs(tournament: Tournament, isEditable: boolean) {
  return useMemo(
    () =>
      ALL_TABS.filter((o) => {
        const t = o.value;

        if (t === 'Banned' || t === 'Removed') {
          return !isEditable;
        }

        if (t === 'Deleted') {
          return isEditable;
        }

        if (t === 'JoinRequest') {
          return tournament.participantPreModerationEnabled;
        }

        if (t === 'Invited') {
          return !tournament.participantPreModerationEnabled;
        }

        return true;
      }),
    [tournament.participantPreModerationEnabled, isEditable],
  );
}
